import React from 'react';
import Heartbeats from './Heartbeats';

class NosedivesReport extends React.Component {
	render (){
		return <Heartbeats metrics="decline" {...this.props} />
	}
}
export default NosedivesReport;